export default __webpack_public_path__ + "static/media/fergus_page_two.00af797c.svg";